import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type IChangeHistorySlice = {
    temp_updated_by : string,
    temp_updated_on : string,
    conf_updated_by : string,
    conf_updated_on : string
}

const initialState: IChangeHistorySlice = {
    temp_updated_by : "",
    temp_updated_on : "",
    conf_updated_by : "",
    conf_updated_on : ""
}

export const changeHistorySlice = createSlice({
    name: 'changeHistorySlice',
    initialState: initialState,
    reducers: {
        setTemperatureUpdatedBy: (state, action: PayloadAction<string>) => {
            state.temp_updated_by = action.payload;
        },
        setTemperatureUpdatedOn: (state, action: PayloadAction<string>) => {
            state.temp_updated_on = action.payload;
        },
        setConfigurationUpdatedBy: (state, action: PayloadAction<string>) => {
            state.conf_updated_by = action.payload;
        },
        setConfigurationUpdatedOn: (state, action: PayloadAction<string>) => {
            state.conf_updated_on = action.payload;
        },
        resetTemperatureUpdatedBy: (state, action: PayloadAction<string>) => {
            state.temp_updated_by = initialState.temp_updated_by;
        },
        resetTemperatureUpdatedOn: (state, action: PayloadAction<string>) => {
            state.temp_updated_on = initialState.temp_updated_on;
        },
        resetConfigurationUpdatedBy: (state, action: PayloadAction<string>) => {
            state.conf_updated_by = initialState.conf_updated_by;
        },
        resetConfigurationUpdatedOn: (state, action: PayloadAction<string>) => {
            state.conf_updated_on = initialState.conf_updated_on;
        }
    }
})

export const {
    setTemperatureUpdatedBy,
    setTemperatureUpdatedOn,
    setConfigurationUpdatedBy,
    setConfigurationUpdatedOn,
    resetTemperatureUpdatedBy,
    resetTemperatureUpdatedOn,
    resetConfigurationUpdatedBy,
    resetConfigurationUpdatedOn
} = changeHistorySlice.actions


export default changeHistorySlice.reducer